import {AfterViewInit, Component, Injector, OnInit, ViewChild} from '@angular/core';
import {DateRange} from "@angular/material/datepicker";
import {MatPaginator} from "@angular/material/paginator";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {LoadingService} from '@ui-kit/framework/util/service/loading.service';
import {
  CustomDateRangeChangeEventModel
} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range-change-event.model";
import {CustomDateRangeModel, TimeFrames} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range.model";
import {CrudTransactionsSummary, TransactionsSummary} from "../../transactions.model";
import {TransactionsService} from "../../transactions.service";
import {BasePageComponent} from "@core-components/page-content/base-page.component";

@Component({
  selector: 'app-transactions-schedule',
  templateUrl: './transactions-schedule.component.html',
})
export class TransactionsScheduleComponent extends BasePageComponent implements OnInit, AfterViewInit {
  @ViewChild('paginator') paginator!: MatPaginator;

  transactionScheduleData: CrudTransactionsSummary[] = [];

  dateRange: DateRange<Date | null> = new DateRange<Date | null>(null, null);

  dateFilters: CustomDateRangeModel[] = [
    new CustomDateRangeModel('today', 1, TimeFrames.DAYS, "Today"),
    new CustomDateRangeModel('last_7_days', 7, TimeFrames.DAYS, 'Last 7 days'),
    new CustomDateRangeModel('this_month', 0, TimeFrames.MONTH, 'This month'),
    new CustomDateRangeModel('last_month', 1, TimeFrames.MONTH, 'Last month', true),
    new CustomDateRangeModel('past_3_months', 3, TimeFrames.MONTH, 'Past 3 months'),
  ]

  tableTitle = 'Transactions Schedule';
  currentPage = 1;

  constructor(injector: Injector,
              private transactionsService: TransactionsService,
              public utils: UtilsService,
              public dateUtils: DateUtilsService,
              public loader: LoadingService) {
    super(injector);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  loadTransactionsSchedule() {
    const filters = this.getCurrentFilters();
    this.currentPage = 1;

    this.transactionsService.getTransactionSchedule(filters).subscribe({
      next: (data: TransactionsSummary[]) => {
        this.transactionScheduleData = data.map(m => new CrudTransactionsSummary(m));
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  loadMoreData() {
    this.currentPage++;
    const filters = this.getCurrentFilters();

    const allData = [...this.transactionScheduleData];

    this.transactionsService.getTransactionSchedule(filters).subscribe({
      next: (data: TransactionsSummary[]) => {
        const newData = data.map(m => new CrudTransactionsSummary(m));
        allData.push(...newData);
        this.transactionScheduleData = [...allData];
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  canLoadMoreData() {
    return this.transactionScheduleData.length != 0 && this.transactionScheduleData.length % 1000 == 0;
  }

  getDateRange(event: CustomDateRangeChangeEventModel) {
    if (event.dateRange.start && event.dateRange.end) {
      this.dateRange = event.dateRange;
      this.loadTransactionsSchedule();
    }
  }

  private getCurrentFilters() {
    return [
      {name: 'pageNumber', val: this.currentPage.toString()},
      {name: 'fromDate', val: this.dateUtils.displayShortDate(this.dateRange.start)},
      {name: 'toDate', val: this.dateRange.end ? this.dateUtils.displayShortDate(this.dateRange.end) : null},
    ]
  }

  protected readonly CrudTransactionsSummary = CrudTransactionsSummary;
}
